import { reduxRequest } from "../../../../common/utils/reduxRequest";
import { makeFilterString } from "../../utils/Helper";
import {
  GetAvailablePackageServicesSuccess,
  GetPackageDetailsSuccess,
  GetPackageItemsSuccess,
  GetPackagesSuccess,
  PackagesLoading,
} from "./Action";

export const getPackagesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "list",
    successFunction: GetPackagesSuccess,
    url: `/admin/events/packages${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createPackageRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "add",
    action: variables?.action,
    url: `/admin/events/packages`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getPackageDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "details",
    successFunction: GetPackageDetailsSuccess,
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updatePackageRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "update",
    url: `/admin/events/packages/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const activatePackageRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "activate",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/activate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deactivatePackageRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "deactivate",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/deactivate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deletePackageRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "delete",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getPackageItemsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "items",
    successFunction: GetPackageItemsSuccess,
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/items${makeFilterString(
      variables?.params,
    )}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getAvailablePackageServicesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "available-services",
    successFunction: GetAvailablePackageServicesSuccess,
    action: variables?.action,
    url: `/admin/events/packages/available_services${makeFilterString(
      variables?.params,
    )}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const addPackageItemRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "add-item",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/items`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updatePackageItemRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "update-item",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/items/${variables?.item_id}`,
    method: "put",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const removePackageItemRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PackagesLoading,
    loadingType: "remove-item",
    action: variables?.action,
    url: `/admin/events/packages/${variables?.id}/items/${variables?.item_id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
